<template>
  <ons-page class="l-content">
    <custom-toolbar backLabel="Retour">{{ $t("Mes livraisons") }}</custom-toolbar>

    <div class="container">
      <div v-if="shippings" class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <td></td>
              <td class="text-right">{{ $t("Date prévue") }}</td>
              <td class="text-right">{{ $t("Statut") }}</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(shipping, index) in shippings" :key="index">
              <td>{{ shipping.sav_name }}</td>
              <td class="text-right">{{ shipping.sav_date !== null ? moment(shipping.sav_date).format('DD/MM/YYYY') : 'NC' }}</td>
              <td class="text-right">
                <i class="fas" :class="[shipping.sav_fk_taskStatus == 3 || moment().format() > moment(shipping.sav_date).format() ? 'fa-check' : 'fa-times']"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="!shippings">
        {{ $t("Pas encore de livraison") }}
      </div>
    </div>
  </ons-page>
</template>

<script>
import moment from 'moment'

export default {
  data() {
    return {
      shippings: null,
      moment: moment
    };
  },
  created() {
    axios
      .get('/users/shippings', {
        params: {
          'x-secundo-auth': loggedIn.token,
          'prospect_id': loggedIn.pro_id,
        }
      })
      .then(response => {
        this.shippings = response.data;
        if(this.shippings.length == 0) {
          this.shippings = null;
        }
      });
  }
};
</script>


// WEBPACK FOOTER //
// Shippings.vue?65949468